<template>
  <i-select :value="value" default-label="progressive" :clearable="clearable" @input="input" :disabled="disabled">
    <i-option value="progressive" :label="$t('autocaller_v2.campaign.filter.type.progressive')" />
    <i-option value="predictive" :label="$t('autocaller_v2.campaign.filter.type.predictive')" />
  </i-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: ''
      },
      clearable: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
